import type { FaireProductEntity } from "../../entity_types/product";

export const p_fqa9jztste: FaireProductEntity = {
  token: "p_fqa9jztste",
  type: "product",
  name: "Barbican Cocktail Shaker",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/51dcbc5160b82ebbb6fd3dea827afec88ffc503e35a5be37264a993b123213f0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aac802e550c2511d2c05c75751ed67027b2852379ab85dbdbea48c925d0d5ac1.jpeg",
    "https://cdn.faire.com/fastly/bd949bc0c9708fa66008a3b64d1d1333e5bcacecdd11711191d31e680ba7cc82.jpeg",
    "https://cdn.faire.com/fastly/c59b1ec3e3cd46b217429e819226cb0e27dca8e576a60ca54eed04ea873aa15d.jpeg",
    "https://cdn.faire.com/fastly/bf6b356c68ee3e92736478fe3df27d503f143dda7f66a561ebbcef709ddd4656.jpeg",
    "https://cdn.faire.com/fastly/33faa96d4add929b85caf34a5647657e00ec252b6da48ee4ef5f9ff65507e57f.jpeg",
    "https://cdn.faire.com/fastly/ca72b920ac22c45cb5853b7af77dfad59d9b18ab32858c201429e6744195d34d.jpeg",
  ],
  priceDollars: 60,
  description:
    "BARBICAN is a barware collection inspired by the bold lines and functionality of brutalist architecture. The BARBICAN Shaker is a generously proportioned, Boston-style shaker with a strong, graphic form. The distinct middle section detail creates a secure grip and ensures a spill-free pour. Made from high-grade stainless steel, the two-piece form is easy to use, easy to clean, and made to last.\n\nMaterial: 18/8 stainless steel\nSize: Ø10.5 x 23cm / Ø4.2” x 9”\n\nDishwasher-safe, handwash recommended",
  tags: [],
  msrpDollars: 120,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:27.779Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
